import { Typography } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";

interface Props {
  content: string;
}

const ArtifactAgentUserMessage = ({ content }: Props) => (
  <Typography
    sx={(t) => ({
      alignSelf: "flex-end",
      maxWidth: "85%",
      px: 1.5,
      py: 1,
      borderRadius: "12px 12px 4px 12px",
      bgcolor: makeTintedBackgroundFromColor(t, t.palette.primary.main),
      whiteSpace: "pre-wrap",
      overflowWrap: "anywhere",
    })}
  >
    {content}
  </Typography>
);

export default ArtifactAgentUserMessage;
